import { CommonModule } from '@angular/common';
import { Component, computed, input, output, signal } from '@angular/core';
import { formatDateTime } from '@app/helpers/formatDateTime.helper';
import type { MeetingResponse } from '@app/models/meeting.model';
import { TranslateModule } from '@ngx-translate/core';

type AlertKind = 'pending' | 'scheduled' | 'none';

@Component({
  selector: 'app-meeting-alert',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './meeting-alert.component.html',
  styleUrl: './meeting-alert.component.scss',
})
export class MeetingAlertComponent {
  meeting = input<MeetingResponse | null>(null);
  visible = signal(true);
  loading = input(false);
  cancel = output<string>();
  done = output<string>();

  kind = computed<AlertKind>(() => {
    const meeting = this.meeting();
    if (!meeting) return 'none';
    if (meeting.acceptedDate) return 'scheduled'; // Accepted
    if (meeting.status === 2) return 'pending'; // Offered
    return 'none';
  });

  tone = computed<'warning' | 'info'>(() =>
    this.kind() === 'pending' ? 'warning' : 'info'
  );

  iconClass = computed(() =>
    this.kind() === 'pending' ? 'fa-exclamation' : 'fa-info'
  );

  scheduledAt = computed(() => this.meeting()?.acceptedDate ?? null);
  formattedAt = computed(() => formatDateTime(this.scheduledAt()) || '—');

  onCancel() {
    const meeting = this.meeting();
    if (meeting) this.cancel.emit(meeting.id);
  }
  onDone() {
    const meeting = this.meeting();
    if (meeting) this.done.emit(meeting.id);
  }
}
